import { StateCreator } from 'zustand';
import { ICartData } from './cartData.interface';

export const cartDataSlice: StateCreator<ICartData> = (set) => ({
  cartData: {},
  setCartData(data: Record<string, any>) {
    set(() => ({ cartData: data }));
  },
});
